import type { BaseEvent, OverlayEventType } from '@shared/types'

import { effectRegistry } from '@shared/lib/effect-registry'
import { useEffect } from 'react'

import { audioService } from './AudioService'

/**
 * Воспроизводит звук при монтировании компонента эффекта.
 *
 * Приоритет звука (от высшего к низшему):
 *  1. event.sound — звук, пришедший прямо в теле события с бэкенда
 *     (позволяет менять звук для каждого конкретного события)
 *  2. plugin.sound — звук, зарегистрированный в плагине
 *     (дефолтный звук для всех событий этого типа)
 *
 * DRY: компоненты эффектов вызывают этот хук с event — он сам
 * разбирает приоритеты, не дублируя логику в каждом компоненте.
 *
 * Пример payload с бэкенда:
 * {
 *   "id": "evt_1",
 *   "type": "donation_alert",
 *   "sound": { "src": "https://cdn.example.com/vip-sound.mp3", "volume": 1.0 },
 *   "payload": { "from": "User", "amount": 1000, "currency": "RUB" }
 * }
 */
export function useEffectSound(event: Pick<BaseEvent, 'type' | 'sound'>): void {
  useEffect(() => {
    const soundConfig =
      event.sound ??
      effectRegistry.get(event.type as OverlayEventType)?.sound

    if (!soundConfig) return

    void audioService.play(soundConfig)
  // Воспроизводим только один раз при монтировании
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
